import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "text-danger" }
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "text-danger" }
const _hoisted_26 = { class: "col-lg-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "text-danger" }
const _hoisted_30 = { class: "col-lg-6" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "text-danger" }
const _hoisted_34 = { class: "col-lg-6" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "text-danger" }
const _hoisted_38 = { class: "col-lg-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = { class: "text-danger" }
const _hoisted_42 = { class: "col-lg-12" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "text-danger" }
const _hoisted_46 = { class: "col-lg-3" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = { class: "text-danger" }
const _hoisted_50 = { class: "col-lg-3" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "text-danger" }
const _hoisted_54 = { class: "col-lg-3" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = { class: "text-danger" }
const _hoisted_58 = { class: "col-lg-3" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = { class: "text-danger" }
const _hoisted_62 = { class: "col-lg-3" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = { class: "text-danger" }
const _hoisted_66 = { class: "col-lg-3" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = { class: "text-danger" }
const _hoisted_70 = { class: "col-lg-3" }
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = { class: "text-danger" }
const _hoisted_74 = { class: "col-lg-3" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = { class: "text-danger" }
const _hoisted_78 = { class: "col-lg-4" }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = { class: "text-danger" }
const _hoisted_82 = { class: "col-lg-4" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = { class: "form-group" }
const _hoisted_85 = { class: "text-danger" }
const _hoisted_86 = { class: "col-lg-4" }
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = { class: "text-danger" }
const _hoisted_90 = { class: "col-lg-4" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { VesselDataPayload } from "@/types/interface/vessel";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useVesselStore } from "@/stores/master/vessel";
import { formatDate, mapOptionMultiselect } from "@/utils/helper";
import { useVesselClass } from "@/stores/master/vessel-class";
import { useVesselType } from "@/stores/master/vessel-type";
import { usePortStore } from "@/stores/master/port";
import { useShipOwnerCompanyStore } from "@/stores/master/ship-owner-company";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateVessel',
  setup(__props) {

const idShip = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const vesselStore = useVesselStore();
const vesselClassStore = useVesselClass();
const vesselTypeStore = useVesselType();
const shipOwnerStore = useShipOwnerCompanyStore();
const listClass = ref<any>();
const listTypeVessel = ref<any>();
const detailVessel = ref<any>();
const listPort = ref<any>();
const portStore = usePortStore();
const listShipOwner = ref([]);

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Vessel Name is required" }),
    imo: zod.string(),
    mmsi: zod.string(),
    call_sign: zod.string().nonempty({ message: "Call Sign is required" }),
    keel_laid: zod.string().nonempty({ message: "Keel Laid is required" }),
    registry_under_company: zod
      .string()
      .nonempty({ message: "Registry Under Company Date is required" }),
    ship_owner: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    vessel_class_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    port_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    vessel_type_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    load_cap: zod.preprocess((val) => Number(val), zod.number()),
    service_speed: zod.preprocess((val) => Number(val), zod.number()),
    gross_tonnage: zod.preprocess((val) => Number(val), zod.number()),
    net_tonnage: zod.preprocess((val) => Number(val), zod.number()),
    deadweight: zod.preprocess((val) => Number(val), zod.number()),
    len_overall: zod.preprocess((val) => Number(val), zod.number()),
    breadth: zod.preprocess((val) => Number(val), zod.number()),
    depth: zod.preprocess((val) => Number(val), zod.number()),
    me_maker: zod.string(),
    type: zod.string(),
    power: zod.string(),
    year: zod.string(),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: imo } = useField<string>("imo");
const { value: mmsi } = useField<string>("mmsi");
const { value: call_sign } = useField<string>("call_sign");
const { value: keel_laid } = useField<string>("keel_laid");
const { value: registry_under_company } = useField<string>(
  "registry_under_company"
);
const { value: ship_owner } = useField<any>("ship_owner");
const { value: vessel_class_id } = useField<any>("vessel_class_id");
const { value: port_id } = useField<string>("port_id");
const { value: vessel_type_id } = useField<any>("vessel_type_id");
const { value: load_cap } = useField<number>("load_cap");
const { value: service_speed } = useField<number>("service_speed");
const { value: gross_tonnage } = useField<number>("gross_tonnage");
const { value: net_tonnage } = useField<number>("net_tonnage");
const { value: deadweight } = useField<number>("deadweight");
const { value: len_overall } = useField<number>("len_overall");
const { value: breadth } = useField<number>("breadth");
const { value: depth } = useField<number>("depth");
const { value: me_maker } = useField<string>("me_maker");
const { value: type } = useField<string>("type");
const { value: power } = useField<string>("power");
const { value: year } = useField<string>("year");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadShip: VesselDataPayload = {
    name: name.value,
    imo: imo.value,
    mmsi: mmsi.value,
    call_sign: call_sign.value,
    keel_laid: keel_laid.value,
    ship_owner_company_id: ship_owner.value?.value,
    registry_under_company: registry_under_company.value,
    vessel_class_id: vessel_class_id.value?.value,
    port_id: port_id.value?.value,
    vessel_type_id: vessel_type_id.value?.value,
    load_cap: load_cap.value,
    service_speed: service_speed.value,
    gross_tonnage: gross_tonnage.value,
    net_tonnage: net_tonnage.value,
    deadweight: deadweight.value,
    len_overall: len_overall.value,
    breadth: breadth.value,
    depth: depth.value,
    me_maker: me_maker.value,
    type: type.value,
    power: power.value,
    year: year.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await vesselStore.dispatchUpdate(
      idShip.value,
      payloadShip
    );
  } else {
    responseApi.value = await vesselStore.dispatchCreate(payloadShip);
  }

  setTimeout(() => {
    toast.success("Ship Created Successfully");
  }, 1000);

  setTimeout(() => {
    isLoading.value = false;
    router.push("/master/vessel");
  }, 1500);
});

const loadListClass = async () => {
  const { success, message } = await vesselClassStore.dispatchGetAll(1, 99);
  if (success) {
    listClass.value = mapOptionMultiselect(
      await vesselClassStore.vesselClassList.items,
      "id",
      "code",
      "name"
    );
  }
};

const loadListVesselType = async () => {
  const { success, message } = await vesselTypeStore.dispatchGetAll(1, 99);
  if (success) {
    listTypeVessel.value = mapOptionMultiselect(
      await vesselTypeStore.vesselTypes.items,
      "id",
      "code",
      "name"
    );
  }
};

const loadListPort = async (query: string) => {
  let queryParam = "&keyword=" + query;
  const { success, message } = await portStore.dispatchGetAll(
    1,
    300,
    queryParam
  );
  if (success) {
    listPort.value = mapOptionMultiselect(
      await portStore.ports.items,
      "id",
      "name",
      "country"
    );
  }
};

let debounceTimeoutPort: any;

const handleSearchPort = (query: string) => {
  clearTimeout(debounceTimeoutPort);
  debounceTimeoutPort = setTimeout(() => {
    loadListPort(query);
  }, 500);
};

const loadListShipOwner = async () => {
  const { success, message } = await shipOwnerStore.dispatchGetList(1, 99, "");
  listShipOwner.value = mapOptionMultiselect(
    shipOwnerStore.owners.items,
    "id",
    "name"
  );
};

const loadDetailVessel = async () => {
  const { success, message } = await vesselStore.dispatchDetail(idShip.value);
  detailVessel.value = await vesselStore?.vessel?.data;
  name.value = detailVessel.value?.name;
  breadth.value = detailVessel.value?.breadth;
  imo.value = detailVessel.value?.imo;
  mmsi.value = detailVessel.value?.mmsi;
  call_sign.value = detailVessel.value?.call_sign;
  keel_laid.value = formatDate(detailVessel.value?.keel_laid);
  ship_owner.value = mapOptionMultiselect(
    detailVessel.value?.ship_owner_company
  );
  registry_under_company.value = formatDate(
    detailVessel.value?.registry_under_company
  );
  vessel_class_id.value = mapOptionMultiselect(
    detailVessel.value?.vesselClass,
    "id",
    "name"
  );
  port_id.value = mapOptionMultiselect(
    detailVessel.value?.port,
    "id",
    "name",
    "country"
  );
  vessel_type_id.value = mapOptionMultiselect(
    detailVessel.value?.vesselType,
    "id",
    "name"
  );
  load_cap.value = detailVessel.value?.load_cap;
  service_speed.value = detailVessel.value?.service_speed;
  gross_tonnage.value = detailVessel.value?.gross_tonnage;
  net_tonnage.value = detailVessel.value?.net_tonnage;
  deadweight.value = detailVessel.value?.deadweight;
  len_overall.value = detailVessel.value?.len_overall;
  depth.value = detailVessel.value?.depth;
  me_maker.value = detailVessel.value?.me_maker;
  type.value = detailVessel.value?.type;
  power.value = detailVessel.value?.power;
  year.value = detailVessel.value?.year;
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idShip.value = router.currentRoute.value.params.id.toString();
    loadDetailVessel();
  }
  loadListShipOwner();
  loadListClass();
  loadListVesselType();
  loadListPort();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Ship"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/ship"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Ship ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Vessel Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Vessel Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", {
                        for: "imo",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("IMO Number "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "imo",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(imo) ? (imo).value = $event : null)),
                          placeholder: "IMO Number",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(imo)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).imo), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        for: "mmsi",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("MMSI "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "mmsi",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(mmsi) ? (mmsi).value = $event : null)),
                          placeholder: "MMSI",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(mmsi)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).mmsi), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", {
                        for: "call_sign",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Call Sign "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "call_sign",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(call_sign) ? (call_sign).value = $event : null)),
                          placeholder: "Call Sign",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(call_sign)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).call_sign), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", {
                        for: "keel_laid",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Keel Laid "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          name: "keel_laid",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(keel_laid) ? (keel_laid).value = $event : null)),
                          placeholder: "Keel Laid",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(keel_laid)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(errors).keel_laid), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", {
                        for: "ship_owner",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Ship Owner "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(ship_owner),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(ship_owner) ? (ship_owner).value = $event : null)),
                          options: listShipOwner.value,
                          placeholder: "Choose Ship Owner"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(errors).ship_owner), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", {
                        for: "registry_under_company",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Registry Under Company "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("input", {
                          name: "registry_under_company",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(registry_under_company) ? (registry_under_company).value = $event : null)),
                          class: "form-control text-dark",
                          type: "date"
                        }, null, 512), [
                          [_vModelText, _unref(registry_under_company)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(errors).registry_under_company), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", {
                        for: "vessel_class_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Vessel Class "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(vessel_class_id),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(vessel_class_id) ? (vessel_class_id).value = $event : null)),
                          options: listClass.value,
                          placeholder: "Vessel Class"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(errors).vessel_class_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", {
                        for: "port_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Port of Registry "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(port_id),
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(port_id) ? (port_id).value = $event : null)),
                          options: listPort.value,
                          placeholder: "Port of Registry",
                          onSearch: handleSearchPort
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(errors).port_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", {
                        for: "vessel_type_id",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Type Of Vessel "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(vessel_type_id),
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(vessel_type_id) ? (vessel_type_id).value = $event : null)),
                          options: listTypeVessel.value,
                          placeholder: "Type of Vessel"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(errors).vessel_type_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", {
                        for: "load_cap",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Load Capacity (mt) "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_48, [
                        _withDirectives(_createElementVNode("input", {
                          name: "load_cap",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(load_cap) ? (load_cap).value = $event : null)),
                          placeholder: "Load Capacity (mt)",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(load_cap)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(errors).load_cap), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", {
                        for: "service_speed",
                        class: "form-label label text-secondary"
                      }, "Service Speed (knots)", -1)),
                      _createElementVNode("div", _hoisted_52, [
                        _withDirectives(_createElementVNode("input", {
                          name: "service_speed",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(service_speed) ? (service_speed).value = $event : null)),
                          placeholder: "Service Speed (knots)",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(service_speed)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(errors).service_speed), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", {
                        for: "gross_tonnage",
                        class: "form-label label text-secondary"
                      }, "Gross Tonnage", -1)),
                      _createElementVNode("div", _hoisted_56, [
                        _withDirectives(_createElementVNode("input", {
                          name: "gross_tonnage",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(gross_tonnage) ? (gross_tonnage).value = $event : null)),
                          placeholder: "Gross Tonnage",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(gross_tonnage)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(errors).gross_tonnage), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", {
                        for: "net_tonnage",
                        class: "form-label label text-secondary"
                      }, "Net Tonnage", -1)),
                      _createElementVNode("div", _hoisted_60, [
                        _withDirectives(_createElementVNode("input", {
                          name: "net_tonnage",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(net_tonnage) ? (net_tonnage).value = $event : null)),
                          placeholder: "Net Tonnage",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(net_tonnage)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(errors).net_tonnage), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", {
                        for: "deadweight",
                        class: "form-label label text-secondary"
                      }, "Deadweight", -1)),
                      _createElementVNode("div", _hoisted_64, [
                        _withDirectives(_createElementVNode("input", {
                          name: "deadweight",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(deadweight) ? (deadweight).value = $event : null)),
                          placeholder: "Deadweight",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(deadweight)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(errors).deadweight), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", {
                        for: "len_overall",
                        class: "form-label label text-secondary"
                      }, "Len Overall (meters)", -1)),
                      _createElementVNode("div", _hoisted_68, [
                        _withDirectives(_createElementVNode("input", {
                          name: "len_overall",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(len_overall) ? (len_overall).value = $event : null)),
                          placeholder: "Len Overall (meters)",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(len_overall)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(errors).len_overall), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", {
                        for: "breadth",
                        class: "form-label label text-secondary"
                      }, "Breadth (meters)", -1)),
                      _createElementVNode("div", _hoisted_72, [
                        _withDirectives(_createElementVNode("input", {
                          name: "breadth",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(breadth) ? (breadth).value = $event : null)),
                          placeholder: "Breadth (meters)",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(breadth)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(errors).breadth), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", {
                        for: "depth",
                        class: "form-label label text-secondary"
                      }, "Depth (meters)", -1)),
                      _createElementVNode("div", _hoisted_76, [
                        _withDirectives(_createElementVNode("input", {
                          name: "depth",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(depth) ? (depth).value = $event : null)),
                          placeholder: "Depth (meters)",
                          class: "form-control text-dark",
                          type: "number",
                          step: "any"
                        }, null, 512), [
                          [_vModelText, _unref(depth)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(errors).depth), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", {
                        for: "me_maker",
                        class: "form-label label text-secondary"
                      }, "Main Engine Maker", -1)),
                      _createElementVNode("div", _hoisted_80, [
                        _withDirectives(_createElementVNode("input", {
                          name: "me_maker",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(me_maker) ? (me_maker).value = $event : null)),
                          placeholder: "Main Engine Maker",
                          class: "form-control text-dark",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _unref(me_maker)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_81, _toDisplayString(_unref(errors).me_maker), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _cache[42] || (_cache[42] = _createElementVNode("label", {
                        for: "type",
                        class: "form-label label text-secondary"
                      }, "Engine Type", -1)),
                      _createElementVNode("div", _hoisted_84, [
                        _withDirectives(_createElementVNode("input", {
                          name: "type",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(type) ? (type).value = $event : null)),
                          placeholder: "Engine Type",
                          class: "form-control text-dark",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _unref(type)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_85, _toDisplayString(_unref(errors).type), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _cache[43] || (_cache[43] = _createElementVNode("label", {
                        for: "power",
                        class: "form-label label text-secondary"
                      }, "Power", -1)),
                      _createElementVNode("div", _hoisted_88, [
                        _withDirectives(_createElementVNode("input", {
                          name: "power",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(power) ? (power).value = $event : null)),
                          placeholder: "Power",
                          class: "form-control text-dark",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _unref(power)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_89, _toDisplayString(_unref(errors).power), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", {
                        for: "year",
                        class: "form-label label text-secondary"
                      }, "Year", -1)),
                      _createElementVNode("div", _hoisted_92, [
                        _withDirectives(_createElementVNode("input", {
                          name: "year",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(year) ? (year).value = $event : null)),
                          placeholder: "Year",
                          class: "form-control text-dark",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _unref(year)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_93, _toDisplayString(_unref(errors).year), 1)
                    ])
                  ]),
                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})